
import { NgModule } from '@angular/core';
import { convertFrom24To12FormatPipe } from './convertFrom24To12Format.pipe';
import { FormatDate } from './formatDate.pipe';
import { meduimDateFormatPipe } from './meduimDate.pipe';
import { NumberMaskPipe } from './number-mask.pipe';
import { ShowPipe } from './showField.pipe';
import { FirstLetterPipe } from './first-letter.pipe';
import { NumbersFormatPipe } from './numbers-format.pipe';
import { KsaTimeAgoPipe } from './ksa-time-ago.pipe';
import { StatusDisplayPipe } from './statusNamingTransform.pipe';


@NgModule({
  imports: [
    // dep modules

  ],
  declarations: [
    convertFrom24To12FormatPipe,
    meduimDateFormatPipe,
    FormatDate,
    NumberMaskPipe,
    ShowPipe,
    FirstLetterPipe,
    NumbersFormatPipe,
    KsaTimeAgoPipe,
    StatusDisplayPipe
  ],
  exports: [
    convertFrom24To12FormatPipe,
    meduimDateFormatPipe,
    FormatDate,
    NumberMaskPipe,
    ShowPipe,
    FirstLetterPipe,
    NumbersFormatPipe,
    KsaTimeAgoPipe,
    StatusDisplayPipe
  ]
})
export class ApplicationPipesModule { }